import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteEventItem($companyId: ID!, $id: ID!) {
    deleteEventItem(companyId: $companyId, id: $id) {
      eventItem {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
